import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export function useFetchExportDetailsData(
  email,
  url,
  apiParams,
  apiType = "get",
  exportIsRunning = false //this will only be enabled when the export is running - such as during an export scenario when the export is not running
) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchExportDetailsDataResultKey";

  async function GetDetailsData() {
    const accessToken = oktaAuth.getAccessToken();
    if (apiType === "post") {
      var result = await axios
        .post(url, apiParams, {
          headers: { Authorization: `Bearer ${accessToken}` },
        }).then((response) => {
          return response.data;
        })
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }
    else {
      var result = await axios
        .get(url, {
          params: apiParams,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          throw new Error(error);
        });

      return result;
    }
  }

  function IsEnabled() {
    if (IsNullOrEmpty(apiParams)) return false;

    return exportIsRunning;
  }

  return useQuery({
    queryKey: [dataKey, url, apiParams],
    queryFn: async () => await GetDetailsData(),
    enabled: IsEnabled,
  });
}
